import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import React, { useCallback, useState } from "react";
import Modal from "../ui/Modal";
import chevronRight from "../../assets/icons/chevron-right.svg";
import chevronLeft from "../../assets/icons/chevron-left.svg";

const PhotoCarousel = ({ photoData, bannerTitle = null, enabled }) => {
    const [swiperRef, setSwiperRef] = useState();
    const [counter, setCounter] = useState(1);

    const [showModal, setShowModal] = useState(false);
    const [initialSlide, setInitialSlide] = useState(0);
    const [modalSwiperRef, setModalSwiperRef] = useState();
    const [modalCounter, setModalCounter] = useState(1);

    const prevClickHandler = useCallback(() => swiperRef?.slidePrev(), [swiperRef]);
    const nextClickHandler = useCallback(() => swiperRef?.slideNext(), [swiperRef]);
    const modalPrevHandler = useCallback(() => modalSwiperRef?.slidePrev(), [modalSwiperRef]);
    const modalNextHandler = useCallback(() => modalSwiperRef?.slideNext(), [modalSwiperRef]);

    const setCounterHandler = (swiper) => {
        if (swiper) setCounter(swiper.realIndex + 1);
    };

    const handleImageClick = (index) => {
        setInitialSlide(index);
        setModalCounter(index + 1);
        setShowModal(true);
    };

    return (
        <>
            {photoData && photoData.length > 0 && (
                <div className="photo-carousel">
                    {enabled !== false ? (
                        <Swiper
                            onActiveIndexChange={() => setCounterHandler(swiperRef)}
                            onSwiper={setSwiperRef}
                            grabCursor={true}
                            speed={400}
                            loop={true}
                            modules={[Navigation, A11y]}
                            touchStartPreventDefault={false}
                            className="swiper"
                            slidesPerView="auto"
                        >
                            {photoData.map((photo, index) => (
                                <SwiperSlide key={`slider${photo.id}`}>
                                    <img
                                        className="swiper__image swiper__image--clickable"
                                        src={photo.url}
                                        alt={photo.alt || ""}
                                        onClick={() => handleImageClick(index)}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <img
                            className="photo-carousel__single-image"
                            alt={photoData[0].alt || bannerTitle || ""}
                            src={photoData[0].url}
                        />
                    )}

                    {bannerTitle && <div className="photo-carousel__banner-title">{bannerTitle}</div>}

                    {enabled !== false && (
                        <>
                            <div className="photo-carousel__counter">
                                {counter}/{photoData.length}
                            </div>
                            <button type="button" onClick={prevClickHandler} className="swiper-nav-button">
                                Prev
                                <img src={chevronLeft} alt="" />
                            </button>
                            <button
                                type="button"
                                onClick={nextClickHandler}
                                className="swiper-nav-button swiper-nav-button__next"
                            >
                                Next
                                <img src={chevronRight} alt="" />
                            </button>
                        </>
                    )}
                </div>
            )}

            <Modal
                modalVisible={showModal}
                closeModal={() => setShowModal(false)}
                modalClassNames="modal--floorplan-slideshow"
                closeCrossColour="black"
            >
                <div className="floorplan-slideshow">
                    {photoData && photoData.length > 1 && (
                        <>
                            <div className="floorplan-slideshow__counter">
                                {modalCounter}/{photoData.length}
                            </div>
                            <button
                                type="button"
                                onClick={modalPrevHandler}
                                className="swiper-nav-button floorplan-slideshow__nav-button floorplan-slideshow__nav-button--prev"
                            >
                                Prev
                                <img src={chevronLeft} alt="" />
                            </button>
                            <button
                                type="button"
                                onClick={modalNextHandler}
                                className="swiper-nav-button swiper-nav-button__next floorplan-slideshow__nav-button floorplan-slideshow__nav-button--next"
                            >
                                Next
                                <img src={chevronRight} alt="" />
                            </button>
                        </>
                    )}
                    <Swiper
                        onSwiper={setModalSwiperRef}
                        onActiveIndexChange={(swiper) => setModalCounter(swiper.realIndex + 1)}
                        initialSlide={initialSlide}
                        grabCursor={true}
                        speed={400}
                        loop={photoData && photoData.length > 1}
                        modules={[Navigation, A11y]}
                        touchStartPreventDefault={false}
                        className="floorplan-slideshow__swiper"
                        slidesPerView={1}
                    >
                        {photoData &&
                            photoData.map((photo, index) => (
                                <SwiperSlide key={index} className="floorplan-slideshow__slide">
                                    <div className="floorplan-slideshow__image-wrapper">
                                        <img
                                            className="floorplan-slideshow__image"
                                            src={photo.url}
                                            alt={photo.alt || `Photo ${index + 1}`}
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>
            </Modal>
        </>
    );
};

export default PhotoCarousel;
